import request from '@/utils/request'

// 投资者信心指数
export function getIndex (data) {
  return request({
    url: '/investor/index',
    method: 'get',
    params: data
  })
}

// 投资者信心指数最大年月
export function getDate () {
  return request({
    url: '/investor/index/date',
    method: 'get'
  })
}
// 投资者信心指数报表数据
export function getChart () {
  return request({
    url: '/investor/index/chart',
    method: 'get'
  })
}

// 投资者满意度指数
export function satisfaction () {
  return request({
    url: '/investor/satisfaction',
    method: 'get'
  })
}

// 上市公司投保状况评价数据最大年
export function getMaxDate () {
  return request({
    url: '/investor/score/date',
    method: 'get'
  })
}

// 上市公司投保评价得分
export function getScore () {
  return request({
    url: '/investor/score',
    method: 'get'
  })
}
// 上市公司投保评价得分
export function getDetail (data) {
  return request({
    url: '/investor/score/detail',
    method: 'get',
    params: data
  })
}

// 投资者意见诉求数据最大年
export function getOpinionDate () {
  return request({
    url: '/investor/opinion/date',
    method: 'get'
  })
}
// 投资者意见诉求数据
export function getOpinionData (data) {
  return request({
    url: '/investor/opinion',
    method: 'get',
    params: data
  })
}

// 专项调查评价报告数据最大年
export function getSurveyDate () {
  return request({
    url: '/investor/survey/date',
    method: 'get'
  })
}
// 专项调查评价报告数据
export function getSurveyData (data) {
  return request({
    url: '/investor/survey',
    method: 'get',
    params: data
  })
}

// 专项调查评价报告数据下载
export function downloadSurvey (data) {
  return request({
    url: '/download/investor/survey',
    method: 'get',
    params: data
  })
}
